import React from 'react';
import {Link} from "react-router";
import sizmek from "../assets/sizmek.png";

function DijitalNetwork() {
    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
          <span className="breadcumb__title">
            <span className="breadcumb__title-lighten">Audiotime</span> DİJİTAL RADYO ENVANTERİ
          </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            {" "}
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>{" "}
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">DİJİTAL NETWORK</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="py-120 justify-content-center" style={{textAlign: "center"}}>
                <div className="container">
                    <div className="row gy-4 justify-content-center">
                        <div className="col-md-12 justify-content-center">
                            <h2 className="section-heading__title justify-content-center">
                                <span
                                    className="section-heading__title-colored">Toplam 9.600.000 Tekil Dinleyici</span>{" "}
                            </h2>
                        </div>
                    </div>
                    <div
                        data-mesh-id="comp-m17mircj1inlineContent-gridContainer"
                        data-testid="mesh-container-content"
                    >


                        <div id="comp-m5mkdufh" className="MazNVa comp-m5mkdufh wixui-image">
                            <div data-testid="linkElement" className="j7pOnl">
                                <img
                                    fetchpriority="high"
                                    sizes="737px"
                                    srcSet="https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_737,h_122,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png 1x, https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_1302,h_216,al_c,lg_1,q_85,enc_avif,quality_auto/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png 2x"
                                    id="img_comp-m5mkdufh"
                                    src="https://static.wixstatic.com/media/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png/v1/fill/w_737,h_122,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/48b701_c5b465ba23c645c992cab6068985d39c~mv2.png"
                                    alt=""
                                    className="BI8PVQ Tj01hh"
                                    width={737}
                                    height={122}
                                    style={{objectFit: "cover"}}
                                />
                            </div>
                        </div>
                        <div id="comp-m5mkea9h" className="MazNVa comp-m5mkea9h wixui-image">
                            <div data-testid="linkElement" className="j7pOnl">
                                <img
                                    fetchpriority="high"
                                    sizes="979px"
                                    srcSet="https://static.wixstatic.com/media/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png/v1/fill/w_979,h_770,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png 1x, https://static.wixstatic.com/media/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png/v1/fill/w_985,h_775,al_c,q_90,enc_avif,quality_auto/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png 2x"
                                    id="img_comp-m5mkea9h"
                                    src="https://static.wixstatic.com/media/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png/v1/fill/w_979,h_770,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/48b701_ab6bc0c1d7da419fa967dce7de7519b2~mv2.png"
                                    alt=""
                                    className="BI8PVQ Tj01hh"
                                    width={979}
                                    height={770}
                                    style={{objectFit: "cover"}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="py-4 section-heading__desc">
                        Her Müzik Zevkine Uygun Yüclerce Radyo detaylı network listesine ulaşmak için <Link
                        style={{color: "#0a0a0a", fontWeight: "bold"}} to="/iletisime-gecin" reloadDocument>bize
                        ulaşın</Link>...

                    </div>

                </div>
            </section>
            <section className="faq py-120">
                <div className="container">
                    <div className="row gy-4 align-items-start align-items-lg-center">
                        <div className="col-lg-5 col-lg-6">
                            <div className="section-heading style-two">
                                <h5 className="section-heading__subtitle">
                                    <span className="section-heading__bars lightBar bars-one"/> GÜVENİLİRLİK{" "}
                                    <span className="section-heading__bars lightBar bars-two"/>
                                </h5>
                                <h2 className="section-heading__title">
                                    {" "}
                                    <span className="section-heading__title-colored">Audiotime</span>{" "} Dijital
                                    Network

                                </h2>
                                <p className="section-heading__desc">
                                    Güvenilir Ölçüm ve İleri Düzey Hedefleme Seçenekleri
                                    <br/><br/>
                                    Güvenilir Ölçüm ve İleri Düzey Hedefleme Seçenekleri

                                    <br/><br/>

                                    100’lerce Radyo 21 milyon farklı ip üzerinden duplikasyonlardan arındırılmış 9
                                    milyon+ tekil dinleyici ve 155 milyondan fazla oturum ile hedef kitlenize ulaşın.

                                    <br/><br/>

                                    Dünyanın en iyi reklam teknolojilerini sağlayan firmalarla partneriz. Bu
                                    teknolojiler ile reklamverenlerimize ileri düzey hedeflemeler, anlık raporlamalar ve
                                    güvenilir ölçümleme sağlıyoruz.
                                    <br/>
                                    <br/>
                                    Sunucularımız “SIZMEK by Amazon” Sertifikasyonuna sahiptir.
                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6 col-lg-6 ps-lg-5">
                            <div className="accordion-right">
                                <div className="accordion-right__thumb">
                                    <img src={sizmek} alt="sizmek"/>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default DijitalNetwork;